module.exports = __webpack_public_path__ + "static/media/jttechlead.8c983d77.jpg";